module.exports = __webpack_public_path__ + "assets/img/d571-tn.svg";